import { KatIcon } from '@amzn/katal-react';
import React from 'react';
import { Transforms } from 'slate';
import {
  ReactEditor, RenderElementProps, useSelected, useSlate,
} from 'slate-react';
import { QuoteElement } from 'src/types/CustomSlateTypes';
import QuoteCard from './QuoteCard';

export type QuoteProps = {
  element: QuoteElement;
} & RenderElementProps;

const Quote = ({ element, attributes, children }: QuoteProps) => {
  const selected = useSelected();
  const editor = useSlate();
  const deleteQuoteButton = (
    <button
      data-testid="delete-quote-button"
      aria-label="delete quote"
      slot="trigger"
      type="button"
      className="cursor-pointer border-0 bg-transparent p-0"
      onClick={() => {
        Transforms.removeNodes(editor, {
          at: ReactEditor.findPath(editor, element),
        });
      }}
    >
      <KatIcon name="close" size="small" />
    </button>
  );
  return (
    <div {...attributes} draggable className="mb-4">
      {children}
      <div data-testid="quote-element" className={selected ? 'outline outline-2 outline-kat-eastern' : ''} contentEditable={false}>
        <QuoteCard {...element} actions={deleteQuoteButton} />
      </div>
    </div>
  );
};

export default Quote;
